import { TableCell, TableRow } from "../../ui/table";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "../../ui/tooltip";
import { Button } from "../../ui/button";
import { Pencil, RotateCcw, UserPlus, Lock, Unlock } from 'lucide-react';

function GroupNumberRow({ groupNumber, userName, disComm, groupStatus, isPrimary, userId, fullName, p_FullName, gC_Affiliate, toggle_add_edit_popup, toggle_reset_popup, restrict_release }) {
    return (
            <>
                {groupNumber ? (
                    <TableRow>
                        <TableCell className="font-medium">{groupNumber}</TableCell>
                        <TableCell>{fullName || '-'}</TableCell>
                        <TableCell>{p_FullName || '-'}</TableCell>
                        <TableCell>{gC_Affiliate || '-'}</TableCell>
                        <TableCell>{disComm || '-'}</TableCell>
                        <TableCell>
                            <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${
                                groupStatus === 'Assigned' ? 'bg-green-100 text-green-800' :
                                groupStatus === 'Unassigned' ? 'bg-gray-100 text-gray-800' :
                                'bg-red-100 text-red-800'
                            }`}>
                                {groupStatus}
                            </span>
                        </TableCell>
                        <TableCell>
                            <TooltipProvider>
                                <div className="flex items-center gap-2">
                                    {groupStatus === 'Restricted' && (
                                        <Tooltip>
                                            <TooltipTrigger asChild>
                                                <Button
                                                    variant="ghost"
                                                    size="sm"
                                                    onClick={restrict_release}
                                                    data-tagname="Release"
                                                    data-groupumber={groupNumber}
                                                >
                                                    <Unlock className="h-4 w-4" />
                                                </Button>
                                            </TooltipTrigger>
                                            <TooltipContent>
                                                <p>Release</p>
                                            </TooltipContent>
                                        </Tooltip>
                                    )}

                                    {groupStatus === 'Assigned' && (
                                        <>
                                            <Tooltip>
                                                <TooltipTrigger asChild>
                                                    <Button
                                                        variant="ghost"
                                                        size="sm"
                                                        onClick={toggle_add_edit_popup}
                                                        data-userid={userId}
                                                        data-groupumber={groupNumber}
                                                        data-poptype="edit"
                                                        className="hover:bg-transparent group"
                                                    >
                                                        <Pencil className="h-4 w-4 transition-colors text-gray-600 group-hover:text-orange-500" />
                                                    </Button>
                                                </TooltipTrigger>
                                                <TooltipContent>
                                                    <p>Edit</p>
                                                </TooltipContent>
                                            </Tooltip>
                                            {isPrimary !== true && (
                                            <Tooltip>
                                                <TooltipTrigger asChild>
                                                    <Button
                                                        variant="ghost"
                                                        size="sm"
                                                        onClick={toggle_reset_popup}
                                                        data-groupumber={groupNumber}
                                                        data-username={userName}
                                                        className={`hover:bg-transparent group ${isPrimary ? 'true' : 'false'}`}
                                                    >
                                                        <RotateCcw className="h-4 w-4 transition-colors text-gray-600 group-hover:text-orange-500" />
                                                    </Button>
                                                </TooltipTrigger>
                                                <TooltipContent>
                                                    <p>Reset</p>
                                                </TooltipContent>
                                            </Tooltip>
                                            )}
                                        </>
                                    )}

                                    {groupStatus === 'Unassigned' && (
                                        <>
                                            <Tooltip>
                                                <TooltipTrigger asChild>
                                                    <Button
                                                        variant="ghost"
                                                        size="sm"
                                                        onClick={toggle_add_edit_popup}
                                                        data-groupumber={groupNumber}
                                                        data-poptype="assign"
                                                    >
                                                        <UserPlus className="h-4 w-4" />
                                                    </Button>
                                                </TooltipTrigger>
                                                <TooltipContent>
                                                    <p>Assign</p>
                                                </TooltipContent>
                                            </Tooltip>
                                            <Tooltip>
                                                <TooltipTrigger asChild>
                                                    <Button
                                                        variant="ghost"
                                                        size="sm"
                                                        onClick={restrict_release}
                                                        data-tagname="Restrict"
                                                        data-groupumber={groupNumber}
                                                    >
                                                        <Lock className="h-4 w-4" />
                                                    </Button>
                                                </TooltipTrigger>
                                                <TooltipContent>
                                                    <p>Restrict</p>
                                                </TooltipContent>
                                            </Tooltip>
                                        </>
                                    )}
                                </div>
                            </TooltipProvider>
                        </TableCell>
                    </TableRow>
                ) : (
                    <TableRow>
                        <TableCell colSpan={7} className="text-center text-gray-500">
                            No Record Found
                        </TableCell>
                    </TableRow>
                )}
            </>
        );
}

export default GroupNumberRow;
